import validator from "validator";

// for functions that can be used in multiple places
const excapeDangerousCharacters = str => validator.escape(str);

const formattedCurrencyString = (currencyNumber, currencySymbol) => {
  const stringifyNumberAddCommas = currencyNumber
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return `${currencySymbol}${stringifyNumberAddCommas}`;
};

const setUrlSoItReturnsToPageOnLogin = (event, cookies, route) => {
  event.preventDefault();
  cookies.set(
    "sitecorePreviousURL",
    window.location.origin + route.fullPath,
    null,
    null,
    ".legrandav.com"
  );
  window.location = event.target.href;
};

// Sign in from anywhere function
function isElementVisible(element) {
  let style = window.getComputedStyle(element);
  if (style.display == "none") {
    return false;
  } else {
    return true;
  }
}

function openSignInMenu() {
  const desktopStickyHeader = document.querySelectorAll(
    "#header-desktop .header-sticky-nav"
  );
  const mobileHeader = document.querySelectorAll("#header-mobile");
  // Mob/tab logic
  if (mobileHeader.length > 0 && isElementVisible(mobileHeader[0])) {
    const mobileNavSignIn = document.querySelectorAll(
      "#header-mobile .header-mobile-menu-bar .header-mobile-right-col .header-actions-container-desktop #NavigationActionSignIn #signin"
    );
    mobileNavSignIn[0].click();
  } else {
    // Desktop logic
    // Desktop sticky nav logic
    if (desktopStickyHeader.length > 0) {
      const stickyNavSignIn = document.querySelectorAll(
        "#header-desktop .header-sticky-nav #header-main-nav-container .fixed-header-actions-container.show-fixed-header-actions .header-actions-container-desktop #NavigationActionSignIn #signin"
      );
      stickyNavSignIn[0].click();
    } else {
      const nonStickyNavSignIn = document.querySelectorAll(
        "#header-desktop .header-utility-menu-desktop .header-actions-container-desktop #NavigationActionSignIn #signin"
      );
      nonStickyNavSignIn[0].click();
    }
  }
}

export default {
  formattedCurrencyString,
  excapeDangerousCharacters,
  setUrlSoItReturnsToPageOnLogin,
  openSignInMenu
};
